import { FormProvider, useForm } from "react-hook-form";
import Input from "./Input";
import { calculateApprovedAmountWeekly, calculateSalaryMultiplierWeekly, monthDiff } from "../utils/calc";
let initialState = {};
const LoanDetails = (props) => {
  const { company, formFields } = props;
  const formRef = useForm(initialState);
  const {
    handleSubmit,
    setValue,
    formState: { isDirty, isValid },
  } = formRef;

  const calculateApprovedAmount = (
    experience,
    avg_salary,
    amount_requested,
    role
    // clientId = null
  ) => {
    let approvedAmount = 0;
    if (role == "Monthly") {
      experience = Number(experience);
      avg_salary = Number(avg_salary);
      let rate = 0;

      // Determine rate based on experience
      if (experience >= 0 && experience < 3) {
        rate = 0;
      } else if (experience >= 3 && experience < 6) {
        rate = 0.5;
      } else if (experience >= 6 && experience < 12) {
        rate = 0.75;
      } else if (experience >= 12 && experience < 18) {
        rate = 1;
      } else if (experience >= 18 && experience < 24) {
        rate = 1.5;
      } else if (experience >= 24) {
        rate = 2;
      }

      // Calculate the approved amount based on rate and limit to LoanConfig.maxAmount
      // console.log('avg_salary * rate',avg_salary , rate, experience)
      approvedAmount = Math.round(avg_salary * rate);
      
      approvedAmount = Math.min(approvedAmount, amount_requested);

    } else if (role == "Weekly") {
      let salaryMultiplier = calculateSalaryMultiplierWeekly(experience);
      approvedAmount = calculateApprovedAmountWeekly(
        salaryMultiplier,
        avg_salary,
        amount_requested
      );

      approvedAmount = Math.min(approvedAmount, amount_requested);
    }

    return approvedAmount;
  };

  const partnerFields = formFields[company]?.filter(
    (field) => field?.page === "loan-details"
  );
  const formValidationsObj = {};
  partnerFields?.forEach((field) => {
    formValidationsObj[field.name] = { ...field };
    initialState[field.name] = "";
    
    // Set max validation for loan_amount based on calculated approved amount
    if (field.name === "loan_amount") {
      const experience = monthDiff(new Date(props.loanData.date_of_joining), new Date())
      const maxAmount = calculateApprovedAmount(
        experience,
        props.loanData.salary_inhand,
        500000,
        props.loanData.salary_frequency
      );
      formValidationsObj[field.name] = {
        ...formValidationsObj[field.name],
        inputInfoText: formValidationsObj[field.name].inputInfoText.replace(
          "loan_amount",
          maxAmount
        ),
      }
      formValidationsObj[field.name].validation = {
        ...formValidationsObj[field.name].validation,
        max: maxAmount,
      };
    }
  });

  

  const redirectToTermsPage = handleSubmit((data) => {
    props?.redirectToStep(data);
  });

  return (
    <>
      <div className="text-2xl text-[#4D4D4D] font-sans font-bold my-7 px-5">
        Enter Loan Details
      </div>
      <FormProvider {...formRef}>
        <form
          onSubmit={(e) => e.preventDefault()}
          noValidate
          autoComplete="off"
          className="my-5 px-5"
        >
          <Input {...formValidationsObj?.loan_amount} />
          <Input {...formValidationsObj?.loan_period} setValue={setValue} />
          <Input {...formValidationsObj?.purpose} setValue={setValue} defaultValue="Default Purpose" />
          <Input {...formValidationsObj?.repayment_frequency} setValue={setValue} />

          <div className="my-7 mx-5 flex items-center justify-center">
            {company === 'moove' && (
              <button
                onClick={() => {
                  localStorage.clear();
                  window.location.reload();
                }}
                className="bg-[#db1d0f] text-white text-base py-2 px-7 rounded disabled:opacity-50 mr-3"
              >
                <span>Reset</span>
              </button>
            )}
            <button
              onClick={redirectToTermsPage}
              disabled={!isDirty || !isValid}
              className="bg-[#4E05FF] text-white text-base py-2 px-3 rounded disabled:opacity-50"
            >
              Continue
            </button>
          </div>
        </form>
      </FormProvider>
    </>
  );
};
export default LoanDetails;
